// extracted by mini-css-extract-plugin
export default {"inputGroup":"input_inputGroup__UXZI0","input":"input_input__7fd2S"};